import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import InputField from "../../ui/form/InputField";
import apiRequest from "../../../utils/admin/apiRequest";
import toast from "react-hot-toast";

const SupportInfo = () => {
  const setting = useSelector((state) => state?.globalState?.siteSetting);
  const siteSetting = setting?.support_info || {};

  const defaultSupportInfo = {
    company: siteSetting?.company,
    support_email: siteSetting?.support_email,
    support_mobile: siteSetting?.support_mobile,
    whatsapp_number: siteSetting?.whatsapp_number,
    address: siteSetting?.address,
    cin: siteSetting?.cin,
    registered_office: siteSetting?.registered_office,
  };

  const [supportInfo, setSupportInfo] = useState(defaultSupportInfo);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (siteSetting?.support_info) {
      setSupportInfo((prev) => ({
        ...prev,
        ...siteSetting.support_info,
      }));
    }
  }, [siteSetting]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSupportInfo((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await apiRequest.updateSetting({
        data: { support_info: supportInfo },
      });
      toast.success(response?.data?.message || "Support info updated.");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update support info.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="space-y-4 bg-white p-4 rounded" onSubmit={handleSubmit}>
      <h2 className="text-lg font-semibold text-gray-700">
        Support Information
      </h2>

      <InputField
        label="Company Name"
        id="company"
        name="company"
        value={supportInfo.company}
        onChange={handleChange}
      />
      <InputField
        label="Support Email"
        id="support_email"
        name="support_email"
        value={supportInfo.support_email}
        onChange={handleChange}
      />
      <InputField
        label="Support Mobile"
        id="support_mobile"
        name="support_mobile"
        value={supportInfo.support_mobile}
        onChange={handleChange}
      />
      <InputField
        label="WhatsApp Number"
        id="whatsapp_number"
        name="whatsapp_number"
        value={supportInfo.whatsapp_number}
        onChange={handleChange}
      />
      <InputField
        label="Support Address"
        id="address"
        name="address"
        value={supportInfo.address}
        onChange={handleChange}
      />
      <InputField
        label="CIN"
        id="cin"
        name="cin"
        value={supportInfo.cin}
        onChange={handleChange}
      />
      <InputField
        label="Registered Office"
        id="registered_office"
        name="registered_office"
        value={supportInfo.registered_office}
        onChange={handleChange}
      />

      <button
        type="submit"
        disabled={loading}
        className="px-4 py-2 text-sm text-white bg-primary rounded hover:bg-primaryDark"
      >
        {loading ? "Saving..." : "Update Info"}
      </button>
    </form>
  );
};

export default SupportInfo;
